export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Информация о контрагенте"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Счет / E-mail / Телефон"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Крипто-адрес / E-mail / Телефон"])}
}